// extracted by mini-css-extract-plugin
module.exports = {"mmicon":"_1lvbKR"};